import { Grid, Heading, Box, List, ListItem, ListIcon, Button, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CheckMarkIcon from '@/assets/icons/ic-check-mark.svg';
import LinkOuterIcon from '@/assets/icons/ic-link-outer.svg';

export const LibrariansResourceCenter: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid
      py={{ base: 10, lg: 24 }}
      templateColumns={{ base: '1fr', lg: '1fr 1fr' }}
      gap={{ base: 0, lg: 14 }}
      gridTemplateAreas={{ base: `"title" "list" "button"`, lg: `"title list" "button list"` }}
    >
      <Heading
        fontSize={{ base: '32px', lg: '48px' }}
        lineHeight={{ base: 10, lg: '60px' }}
        pb={{ base: 14, lg: 10 }}
        pr={{ base: 0, lg: 20 }}
        gridArea="title"
      >
        {t('librarians.resourceCenter.title')}
      </Heading>
      <Box gridArea="button">
        <NextLink href="/librarians-resource" passHref legacyBehavior>
          <Button rightIcon={<LinkOuterIcon />} colorScheme="black" textTransform="capitalize">
            {t('librarians.resourceCenter.button')}
          </Button>
        </NextLink>
      </Box>
      <List gridArea="list" pt={4} pb={{ base: 16, lg: 10 }} spacing={12}>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.resourceCenter.specifications.0')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.resourceCenter.specifications.1')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.resourceCenter.specifications.2')}</Text>
        </ListItem>
        <ListItem fontSize="xl" display="flex">
          <ListIcon as={CheckMarkIcon} bg="violet.500" color="white" w="26px" h="26px" borderRadius={20} mr={5} />
          <Text>{t('librarians.resourceCenter.specifications.3')}</Text>
        </ListItem>
      </List>
    </Grid>
  );
};
